import { Flex, Icon, Spacer, Text } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { BsFolder2 } from 'react-icons/bs'
import { IoIosArrowForward } from 'react-icons/io'
import type { MediaLibrarySearchFolderResponse } from '../../../../interfaces'
import {
  MediaLibraryActions,
  MLContext,
} from '../../../../providers/MLProvider'

interface Props {
  folder: MediaLibrarySearchFolderResponse
  onCloseMovePopup?(): void
}

const FolderElement = ({
  folder,
  onCloseMovePopup,
}: Props): React.ReactElement => {
  const [, dispatch] = useContext(MLContext)
  const { name, folderPath } = folder

  const handleClick: React.MouseEventHandler<HTMLDivElement> = e => {
    e.preventDefault()
    e.stopPropagation()
    if (onCloseMovePopup) {
      onCloseMovePopup()
    }
    dispatch([
      {
        type: MediaLibraryActions.SET_DRAWER_FOLDER,
        payload: folderPath,
      },
      {
        type: MediaLibraryActions.RESET_SECONDARY_FOLDER_PAGE,
      },
      {
        type: MediaLibraryActions.RESET_DRAWER_SEARCH,
      },
    ])
  }

  return (
    <Flex
      align="center"
      padding="1em 0.75em"
      cursor="pointer"
      borderRadius="4px"
      _hover={{ backgroundColor: 'appPaleGreyThree' }}
      onClick={handleClick}
    >
      <Icon as={BsFolder2} boxSize={8} mr={3} />
      <Text color="appDarkIndigo" maxW="70%" isTruncated>
        {name}
      </Text>
      <Spacer />
      <Icon as={IoIosArrowForward} boxSize={4} color="appDarkIndigo" />
    </Flex>
  )
}

export default FolderElement
